export enum ContentType {
  LEARNING_PATH = 'LEARNING_PATH',
  COURSE = 'COURSE',
  LESSON = 'LESSON',
}
